module.exports = __webpack_public_path__ + "img/banner.56808e16.png";